export const FETCH_COMPANY_CONTACT_REQUEST = 'FETCH_COMPANY_CONTACT_REQUEST';
export const FETCH_COMPANY_CONTACT_SUCCESS = 'FETCH_COMPANY_CONTACT_SUCCESS';
export const FETCH_COMPANY_CONTACT_FAILURE = 'FETCH_COMPANY_CONTACT_FAILURE';

export const FETCH_COUNTRIES_REQUEST = 'FETCH_COUNTRIES_REQUEST';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE';
